<template>
  <v-dialog v-model="isActive" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>

    <v-overlay v-if="isLoading" absolute color="#48B38B">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-card>
      <div class="header">
        <div class="content-header">
          <div @click="close()" class="return-screen">
            <v-icon color="white">mdi-close</v-icon>
          </div>
          <div @click="handleAddMethod()" class="add-screen mr-3">
            <v-icon color="primary">mdi-plus</v-icon>
          </div>
          <h2>Formas de Pagamento</h2>
          <div>Atrelar formas de pagamento ao orçamento selecionado</div>
        </div>
      </div>
      <div class="content">
        <v-alert
          class="mx-4 my-4"
          dense
          color="grey lighten-2"
          icon="mdi-information-outline"
        >
          <div class="text-caption text--secondary">Selecione as opções que serão apresentadas no orçamento do cliente.</div>
        </v-alert>
        <v-list
          class="mx-auto"
        >
          <v-list-item v-for="method in localMethods" :key="method.id">
            <v-list-item-action>
              <v-icon>mdi-currency-usd</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ method.description }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-switch
                v-model="selectedMethods"
                color="primary"
                hide-details
                :value="method.id"
                @change="handlePaymentMethodChange(method.id)"
              ></v-switch>
            </v-list-item-action>

            <v-list-item-action>
              <v-btn icon @click="handleEditMethod(method)">
                <v-icon color="primary">mdi-dots-vertical</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </div>
    </v-card>

    <v-bottom-sheet v-model="isAddPaymentMethod" persistent>
      <div class="bottom-sheet-content">
        <div class="bottom-sheet-header">
          <span class="bottom-sheet-title">{{ modalPrefix }} forma</span>
          <v-btn icon @click="closeManageModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-text-field v-model="description" class="py-4" label="Forma de Pagamento" outlined></v-text-field>
        <v-btn color="primary" block @click="managePaymentMethod" :disabled="!description">Salvar</v-btn>
        <v-btn v-if="isEditPaymentMethod" class="mt-4" color="red" outlined block @click="isRemoveDialogActive = true">Excluir</v-btn>
      </div>
    </v-bottom-sheet>

    <v-dialog
      v-model="isRemoveDialogActive"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Remover forma
        </v-card-title>
        <v-card-text>
          Tem certeza que deseja remover esta forma de pagamento?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="isRemoveDialogActive = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeMethod"
          >
            Remover
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

import BudgetPaymentMethodsService from '@/services/api/budgetPaymentMethods';
import PaymentMethodsService from '@/services/api/paymentMethod';

export default {
  name: 'PaymentMethod',
  emits: ['close'],
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    methods: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      isAddPaymentMethod: false,
      isEditPaymentMethod: false,
      isRemoveDialogActive: false,
      description: '',
      selectedMethods: [],
      selectedMethod: null,
      localMethods: [],
    };
  },
  computed: {
    ...mapState('Budget', ['selectedBudget']),
    modalPrefix() {
      return this.selectedMethod ? 'Editar' : 'Nova';
    },
  },
  created() {
    const methods = this.selectedBudget.budget_payment_methods;

    this.selectedMethods = methods ? methods.map((method) => method.payment_method_id) : [];

    this.localMethods = [...this.methods];
  },
  methods: {
    close() {
      this.$emit('close');
    },
    handlePaymentMethodChange(methodId) {
      this.isLoading = true;

      const unstructuredMethods = { ...this.selectedMethods };
      const methods = Object.values(unstructuredMethods);

      const promise = methods.includes(methodId) ? BudgetPaymentMethodsService.create({ budget_id: this.selectedBudget.id, payment_method_id: methodId }) : BudgetPaymentMethodsService.inactivate(this.selectedBudget.id, methodId)

      promise
        .then(() => {
          this.isLoading = false;

          const method = {
            payment_method_id: methodId,
            description: this.localMethods.find((method) => method.id === methodId).description,
          };

          const action = methods.includes(methodId) ? 'ADD_PAYMENT_METHOD' : 'REMOVE_PAYMENT_METHOD';

          this.$store.commit('Budget/MANAGE_PAYMENT_METHODS', { method, action });
        });
    },
    handleAddMethod() {
      this.description = '';
      this.isAddPaymentMethod = true;
    },
    handleEditMethod(method) {
      this.selectedMethod = method;
      this.description = method.description;
      this.isAddPaymentMethod = true;
      this.isEditPaymentMethod = true;
    },
    removeMethod() {
      this.isLoading = true;
      this.isRemoveDialogActive = false;

      this.closeManageModal();

      PaymentMethodsService.inactivate(this.selectedMethod.id)
        .then(() => {
          this.localMethods = this.localMethods.filter((method) => method.id !== this.selectedMethod.id);
          this.isLoading = false;

          const method = {
            payment_method_id: this.selectedMethod.id,
            description: this.selectedMethod.description,
          };

          this.$store.commit('Budget/MANAGE_PAYMENT_METHODS', { method, action: 'REMOVE_PAYMENT_METHOD' });

          this.selectedMethod = null;
        });
    },
    managePaymentMethod() {
      this.isLoading = true;
      this.isAddPaymentMethod = false;

      const promise = this.isEditPaymentMethod
        ? PaymentMethodsService.update(this.selectedMethod.id, { description: this.description })
        : PaymentMethodsService.create({ description: this.description });

        promise
          .then((response) => {
            if (this.isEditPaymentMethod) {
              this.localMethods = this.localMethods.map((method) => {
                if (method.id === response.data.id) {
                  return response.data;
                }

                return method;
              });

              this.closeManageModal();
              this.selectedMethod = null;
            } else {
              BudgetPaymentMethodsService.create({ budget_id: this.selectedBudget.id, payment_method_id: response.data.id });

              this.localMethods.push(response.data);
              this.selectedMethods.push(response.data.id);
            }

            const method = {
              payment_method_id: response.data.id,
              description: response.data.description,
            };

            this.$store.commit('Budget/MANAGE_PAYMENT_METHODS', { method, action: 'ADD_PAYMENT_METHOD'});

            this.isLoading = false;
          });
    },
    closeManageModal() {
      this.isAddPaymentMethod = false;
      this.isEditPaymentMethod = false;
      this.description = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  z-index: 999;
  border-radius: 0px !important;

  .content-header {
    padding: 20px 20px;
    background-color: #3e515f;
    color: #fff;

    .return-screen {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }

    .add-screen {
      float: right;
      background-color: white;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }
  }
}

.bottom-sheet-content {
  padding: 16px;

  .bottom-sheet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .bottom-sheet-title {
      font-size: 18px;
      font-weight: 500;
    }
  }
}
</style>
